import styled from 'styled-components';

import { textOverflow, Tooltip } from '@dreryk/react-components';

export const StyledTooltipCell = styled(Tooltip)`
   ${textOverflow('ellipsis')};
` as typeof Tooltip;
